import script from "./SearchResultMaterialVariants.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResultMaterialVariants.vue?vue&type=script&lang=ts&setup=true"

import "./SearchResultMaterialVariants.vue?vue&type=style&index=0&id=113f7f86&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-113f7f86"]])

export default __exports__